module.exports = "images/teamed_image_04.png";